import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import {
    Button,
    Input,
    SearchField as SearchFieldBase,
} from 'react-aria-components';

import {
    ArrowLeftIcon,
    MagnifyingGlassIcon,
    Text,
    WDSButton,
    XMarkIcon,
} from 'wanderu-components';
import { combineClasses } from 'wanderu-css';

import styles from './SearchField.scss';

const SearchField = ({
    backText,
    classes: classesProp = {},
    clearText,
    closeModal,
    inputValue = '',
    onClear,
    placeholder,
    ...otherProps
})=> {
    const classes = combineClasses(styles, classesProp);

    return (
        <SearchFieldBase
            className={classes.inputContainer}
            defaultValue={inputValue}
            onClear={onClear}
            {...otherProps}
        >
            <WDSButton aria-label={backText} className={classNames(classes.button, classes.hideLarge)} onClick={closeModal} variant="text">
                <ArrowLeftIcon />
            </WDSButton>
            <div className={classNames(classes.iconContainer, classes.hideSmall)}>
                <MagnifyingGlassIcon />
            </div>
            <Input
                className={classes.input}
                placeholder={placeholder}
            />
            <Button className={classes.button} slot="clear" type="reset">
                <XMarkIcon className={classes.hideLarge} />
                <Text className={classes.hideSmall} color="link" component="span" variant="text-l">{clearText}</Text>
            </Button>
        </SearchFieldBase>
    );
};

SearchField.propTypes = {
    backText: PropTypes.string,
    classes: PropTypes.object,
    clearText: PropTypes.string,
    closeModal: PropTypes.func,
    inputValue: PropTypes.string,
    onClear: PropTypes.func,
    placeholder: PropTypes.string,
};

export default SearchField;
